/**
 * 入力サイズ上限。DoS / メモリ枯渇を防ぐため `SpecError("INPUT_TOO_LARGE")` で reject する。
 *
 * 値の根拠 (実運用想定):
 * - 通常の仕様書は数 MB / 数十シート / 各数百行で収まる
 * - 上限は「正常な仕様書がまず到達しない値」を採用 (誤検知ゼロを優先)
 *
 * いずれかを超えた場合 `SpecError("INPUT_TOO_LARGE", message, context)` を throw する。
 * `context` には `{ kind: "file_size" | "sheet_count" | "row_count" | "cell_length",
 * actual, limit, sheetName? }` を渡し、利用側 (UI 文言生成等) が分岐できるようにする。
 */
export const INPUT_LIMITS = {
  /** xlsx ファイルのバイト数上限 (50 MiB) */
  maxFileBytes: 50 * 1024 * 1024,
  /** workbook 内のシート数上限 */
  maxSheetCount: 200,
  /** 1 シート内の行数上限 (!ref の宣言レンジではなく実データの最終行で判定する) */
  maxRowsPerSheet: 20_000,
  /** 1 セル内の文字列長上限 (Excel 公式上限 32767 より小さく、実運用で必要十分な値) */
  maxCellLength: 20_000,
} as const;
